import Vue from "vue";
import "@/utils/http-tracking";
import App from "./App.vue";
import router from "./router";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import Fragment from "vue-fragment";
import Maska from "maska";
import Toast from "vue-toastification";
import VueSidebarMenu from "vue-sidebar-menu";
import vueClickOutsideElement from "vue-click-outside-element";
import VueTelInput from "vue-tel-input";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";

import VueEasyLightbox from "vue-easy-lightbox";

import {
  faAddressCard,
  faAddressBook,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAreaChart,
  faArrowLeft,
  faAward,
  faBalanceScale,
  faBan,
  faBarChart,
  faBars,
  faBinoculars,
  faBook,
  faBuildingFlag,
  faBuildingUser,
  faCalendarAlt,
  faCalendarDay,
  faChalkboardUser,
  faChartColumn,
  faChartLine,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleDown,
  faCircleInfo,
  faCity,
  faClipboard,
  faClipboardCheck,
  faClipboardQuestion,
  faClock,
  faCloudUpload,
  faCodeCompare,
  faCog,
  faCogs,
  faComment,
  faCheckSquare,
  faCrown,
  faDesktop,
  faDownload,
  faDrum,
  faEdit,
  faEnvelope,
  faEnvelopeOpenText,
  faEnvelopesBulk,
  faEraser,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faExclamationCircle,
  faFeatherPointed,
  faFighterJet,
  faFileAlt,
  faFileCircleCheck,
  faFileImport,
  faFileLines,
  faFileInvoice,
  faFilePen,
  faFileSignature,
  faFileUpload,
  faFilter,
  faFilePdf,
  faFileDownload,
  faGavel,
  faHandshake,
  faHome,
  faHistory,
  faHourglassEnd,
  faImage,
  faInfoCircle,
  faKey,
  faKeyboard,
  faLaptop,
  faLink,
  faLock,
  faMasksTheater,
  faMoneyCheckAlt,
  faMoneyCheckDollar,
  faPaperPlane,
  faPaste,
  faPencil,
  faPhone,
  faPhoneVolume,
  faPieChart,
  faPlus,
  faPaperclip,
  faQuestionCircle,
  faReceipt,
  faRectangleList,
  faRedo,
  faRotate,
  faRotateLeft,
  faSave,
  faSchool,
  faSearch,
  faSection,
  faShoppingCart,
  faSitemap,
  faSignOutAlt,
  faSpider,
  faSpinner,
  faSquare,
  faSquareEnvelope,
  faSync,
  faTasks,
  faTimes,
  faTrash,
  faTrophy,
  faUserAlt,
  faUserCheck,
  faUserGroup,
  faUserMinus,
  faUsers,
  faUsersGear,
  faUserTag,
  faUndo,
  faUserPen,
  faUserPlus,
  faUserTie,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
import "vue-toastification/dist/index.css";
import "vue-tel-input/dist/vue-tel-input.css";

import "./validation";
import { initMatomo } from "@/utils/matomo";

library.add(
  faAddressCard,
  faAddressBook,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAreaChart,
  faArrowLeft,
  faAward,
  faBalanceScale,
  faBan,
  faBars,
  faBarChart,
  faBinoculars,
  faBook,
  faBuildingFlag,
  faBuildingUser,
  faCalendarAlt,
  faCalendarDay,
  faChalkboardUser,
  faChartColumn,
  faChartLine,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faCheckSquare,
  faChevronUp,
  faCircleCheck,
  faCircleDown,
  faCircleInfo,
  faCity,
  faClipboard,
  faClipboardCheck,
  faClipboardQuestion,
  faClock,
  faCloudUpload,
  faCodeCompare,
  faCog,
  faCogs,
  faComment,
  faCrown,
  faDesktop,
  faDownload,
  faDrum,
  faEnvelopeOpenText,
  faEdit,
  faEnvelopeOpenText,
  faEnvelope,
  faEnvelopesBulk,
  faEraser,
  faExclamationTriangle,
  faEye,
  faExternalLinkAlt,
  faEyeSlash,
  faExclamationCircle,
  faFeatherPointed,
  faFighterJet,
  faFileAlt,
  faFileCircleCheck,
  faFileImport,
  faFileLines,
  faFileInvoice,
  faFilePdf,
  faFilePen,
  faFileSignature,
  faFileUpload,
  faFilter,
  faFileDownload,
  faGavel,
  faHandshake,
  faHistory,
  faHome,
  faHourglassEnd,
  faImage,
  faInfoCircle,
  faKey,
  faKeyboard,
  faLaptop,
  faLink,
  faLock,
  faMasksTheater,
  faMoneyCheckAlt,
  faMoneyCheckDollar,
  faPaperPlane,
  faPaste,
  faPieChart,
  faPlus,
  faPaperclip,
  faPencil,
  faPhone,
  faPhoneVolume,
  faQuestionCircle,
  faReceipt,
  faRectangleList,
  faRedo,
  faRotate,
  faRotateLeft,
  faSave,
  faSchool,
  faSearch,
  faSection,
  faSitemap,
  faSignOutAlt,
  faShoppingCart,
  faSpider,
  faSpinner,
  faSync,
  faSquare,
  faSquareEnvelope,
  faTasks,
  faTimes,
  faTrash,
  faTrophy,
  faUserAlt,
  faUserCheck,
  faUserGroup,
  faUserMinus,
  faUsers,
  faUsersGear,
  faUserTag,
  faUndo,
  faUserPen,
  faUserPlus,
  faUserTie,
  faXmark,
);

const vueToastOptions = {
  timeout: 5000,
  position: "top-right",
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false,
};

//custom colors/theme
import "./app.scss";

Vue.config.productionTip = false;
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Fragment.Plugin);
Vue.use(Toast, vueToastOptions);
Vue.use(VueSidebarMenu);
Vue.use(vueClickOutsideElement);
Vue.use(Maska);
Vue.use(VueTelInput);
Vue.use(VueEasyLightbox)

export const eventBus = new Vue();

initMatomo();

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
